module.exports = __webpack_public_path__ + "static/media/id-popup-step2.67bc0d41.png";